import { profileRoute } from '@pages/profile-page'
import { createRoute } from '@tanstack/react-router'
import { ProfileInfoPageError } from './profile-info-page.error'

export const profileInfoRoute = createRoute({
  getParentRoute: () => profileRoute,
  loader: () => null,
  errorComponent: ProfileInfoPageError,
  path: 'info'
}).lazy(async () => {
  const d = await import('./profile-info-page.lazy')
  return d.Route
})
